/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TESTIMONIALS_CARD_WIDTH } from 'bundles/front-page/common/constants';
import Slider from 'bundles/front-page/components/modules/slider/Slider';

type Props = {
  articleItems: React.ReactNode[];
};

const styles = {
  sliderWrapper: css`
    width: inherit;
    margin-top: calc(var(--cds-spacing-100) * -1); /* Remove excessive padding from parent Grid */

    // Targets container for cards and nav components
    > div {
      margin: 0;
    }

    // Targets wrapper for slide indicators (dots) and nav arrows
    > div > div:last-of-type {
      margin: var(--cds-spacing-100) var(--cds-spacing-100) 0;
      width: 95%;

      // Dots container
      > div:first-of-type {
        width: 30%;

        // Update styling of active dot
        div[data-testid*='-active'] {
          width: inherit;
          border-radius: inherit;
        }
      }
    }
  `,

  streamlinedXDPArticle: css`
    height: 100%; /* Makes all cards the same height */
    padding: var(--cds-spacing-50);

    a {
      :hover,
      :focus-visible {
        box-shadow: 0 0 6px 1px var(--cds-color-neutral-primary);
        transition: box-shadow 250ms ease-out;
      }
    }

    article {
      box-shadow: none;
      border: 2px solid var(--cds-color-neutral-stroke-primary-weak);

      // Targets article title and desciption
      > div {
        text-wrap: auto;
      }
    }
  `,
};

const ArticleSlider = ({ articleItems }: Props) => {
  if (!articleItems?.length) {
    return null;
  }

  return (
    <div css={styles.sliderWrapper}>
      <Slider forcedCardWidth={TESTIMONIALS_CARD_WIDTH}>
        {articleItems?.map((article, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} css={styles.streamlinedXDPArticle}>
            {article}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ArticleSlider;
